import { render } from "./TabelaPreco.vue?vue&type=template&id=281abf14"
import script from "./TabelaPreco.vue?vue&type=script&lang=ts"
export * from "./TabelaPreco.vue?vue&type=script&lang=ts"
script.render = render

export default script